import {Repository, RequestMethod} from 'b302-frontend-library';
import User from '../models/User';

class AuthRepository extends Repository {

    public constructor() {
        super('/auth');
    }

    public async getCurrentUser(): Promise<User> {
        return this.request<User>(this.url('/me'), RequestMethod.POST).send();
    }
}

export default AuthRepository;
